export default __webpack_public_path__ + "static/media/bocongthuong.cb85045e.png";